import React from 'react'
import { createNgReactBridgeDirective } from '../../../react-bridge'
import { IntegrationsListView } from '../../../../components/integrations'
import {
  Bugtrackers,
  JobOutcomePolicy,
  Webhooks
} from '../../../../components/integrations/common/interfaces'
import {
  CurrentOrganization,
  isCurrentOrganization
} from '../../../../components/current-organization'

interface AngularIntegrationsListViewProps {
  readonly bugtrackers: Bugtrackers
  readonly webhooks: Webhooks
  readonly jobOutcomePolicy: JobOutcomePolicy
  readonly currentOrganization: CurrentOrganization
}

const isValid = (currentOrganization: CurrentOrganization): boolean => {
  return isCurrentOrganization(currentOrganization)
}

function AngularIntegrationsListView(props: AngularIntegrationsListViewProps) {
  return isValid(props.currentOrganization) ? (
    <IntegrationsListView {...props} />
  ) : (
    <></>
  )
}

export const reactIntegrationsListView = createNgReactBridgeDirective(
  'reactIntegrationsListView',
  [],
  AngularIntegrationsListView,
  ['bugtrackers', 'webhooks', 'jobOutcomePolicy', 'currentOrganization']
)
